import { TrendingUp, ShoppingBag, Map, BarChart2, Globe, Activity } from 'lucide-react'
import { useLanguage } from '../context/LanguageContext'

export const PLATFORMS_LIST = [
  { id: 'google_trends', name: 'Google Trends', icon: TrendingUp, section: 'section-trends',     capKey: 'capGoogle' },
  { id: 'pinterest',     name: 'Pinterest',     icon: Activity,   section: 'section-pinterest',  capKey: 'capPinterest' },
  { id: 'aliexpress',    name: 'AliExpress',    icon: ShoppingBag,section: 'section-aliexpress', capKey: 'capAliexpress' },
  { id: 'amazon',        name: 'Amazon',        icon: Globe,      section: 'section-amazon',     capKey: 'capAmazon' },
  { id: 'facebook',      name: 'Facebook Ads',  icon: BarChart2,  section: 'section-facebook',   capKey: 'capFacebook' },
  { id: 'google_maps',   name: 'Google Maps',   icon: Map,        section: 'section-maps',        capKey: 'capMaps' },
  { id: 'google_ads',    name: 'Google Ads',    icon: TrendingUp, section: 'section-keywords',    capKey: 'capGoogleAds' },
  { id: 'dataforseo',   name: 'DataForSEO',    icon: Activity,   section: 'section-keywords',    capKey: 'capDataForSeo' },
]

export default function PlatformCapabilities({ apiStatus = {}, results = null }) {
  const { t } = useLanguage()
  const hasResults = !!results

  const activeSections = new Set()
  if (results) {
    if (results.googleTrends)                               activeSections.add('google_trends')
    if (results.pinterestTrends)                            activeSections.add('pinterest')
    if (results.type === 'PRODUCT' && results.dropshipping) activeSections.add('aliexpress')
    if (results.type === 'PRODUCT' && results.amazon)       activeSections.add('amazon')
    if (results.facebookAds)                                activeSections.add('facebook')
    if (results.type === 'SERVICE' && results.googleMaps)   activeSections.add('google_maps')
  }

  const handleClick = (section) => {
    if (!hasResults) return
    const el = document.getElementById(section)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <div className="p-5 bg-[#111111] border border-[#2a2a2a] rounded-xl">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 flex items-center justify-center bg-[#1e1e1e] rounded-lg border border-[#2a2a2a]">
          <BarChart2 className="w-4 h-4 text-[#8b949e]" />
        </div>
        <div>
          <p className="text-xs font-semibold text-white uppercase tracking-widest">{t('dashboard.analyticalCapabilities')}</p>
          <p className="text-xs text-[#8b949e]">
            {hasResults ? t('dashboard.capabilitiesClickDesc') : t('dashboard.capabilitiesDesc')}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {PLATFORMS_LIST.map(p => {
          const Icon = p.icon
          const configured = apiStatus[p.id]
          const hasData    = activeSections.has(p.id)

          return (
            <div
              key={p.id}
              onClick={() => handleClick(p.section)}
              className={`
                relative p-4 rounded-xl border overflow-hidden
                transition-all duration-300 ease-out group
                bg-[#111111] border-[#2a2a2a]
                hover:bg-white hover:border-white hover:shadow-2xl hover:shadow-white/10 hover:-translate-y-0.5 active:scale-95
                ${hasResults && hasData ? 'cursor-pointer' : 'cursor-default'}
              `}
            >
              {/* Top shimmer line */}
              <div className="absolute top-0 left-0 right-0 h-px rounded-t-xl bg-gradient-to-r from-transparent via-[#4a4a4a] to-transparent opacity-100 group-hover:opacity-0 transition-opacity duration-300" />

              {/* Pulsing dot — cuando tiene datos en la búsqueda actual */}
              {hasData && (
                <span className="absolute top-2.5 right-2.5 w-1.5 h-1.5 rounded-full bg-[#8a8a8a] animate-pulse group-hover:bg-[#1a1a1a]" />
              )}

              <Icon className="w-5 h-5 mb-3 text-[#888888] group-hover:text-[#111111] transition-colors duration-300" />

              <p className="text-xs font-bold mb-1 text-[#cccccc] group-hover:text-[#111111] transition-colors duration-300">
                {p.name}
              </p>

              <p className="text-xs leading-relaxed text-[#555555] group-hover:text-[#444444] transition-colors duration-300">
                {t(`dashboard.${p.capKey}`)}
              </p>

              {/* "Ver métricas →" solo cuando hay datos reales de esa plataforma */}
              {hasResults && hasData && (
                <p className="text-xs text-[#555555] mt-2 font-medium group-hover:text-[#222222] transition-colors duration-300">
                  {t('dashboard.viewMetrics')}
                </p>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
